let STATES = {
  NONE: 0,
  PINGING: 1,
  DONE: 2,
}
let ref = { popup: null };
let state = STATES.NONE;
let url = `${process.env.REACT_APP_MOUNT}/linkedin-auth.html`;
let pingId = 0;
let closeOnDone = false;
let autoAuth = false;
let authRetry = 0;
let openPromise = {
  resolve: null,
  reject: null
}
let authPromise = {
  resolve: null,
  reject: null
}

//-----------------------------------------------
//-----public API

/**
 * Open a window for auth
 * @param {boolean} _autoAuth if true, start auth right away. if false, resolve and allow the user to perform other actions like resize/move window
 * @param {boolean} _closeOnDone only used if _autoAuth = true
 * @param {string} _windowOptions same options string as 3rd param of window.open
 * @returns {Promise}
 */
export function openLinkedIn(_autoAuth = false, _closeOnDone = true, _windowOptions = "width=400,height=600,location=yes") {
  autoAuth = _autoAuth;
  closeOnDone = _closeOnDone;
  return new Promise((resolve, reject) => {
    openPromise.resolve = resolve;
    openPromise.reject = reject;

    window.removeEventListener("message", handleMessage);
    window.addEventListener("message", handleMessage);
    ref.popup = window.open(url, "glg-linkedin-auth", _windowOptions);
    if (!ref.popup) {
      return reject({ message: "popup blocked" })
    }
    state = STATES.PINGING;
    startPing(1);
  })
}
/**
 * Start the auth proccess
 * @param {boolean} _closeOnDone close thne window when auth is done/cancelled
 * @returns {Promise}
 */
function auth(_closeOnDone = true) {
  closeOnDone = _closeOnDone;
  return new Promise((resolve, reject) => {
    authPromise.resolve = resolve;
    authPromise.reject = reject;
    if (!ref.popup || ref.popup.closed) {
      return authPromise.reject({ message: "no popup opened" });
    }
    authRetry = 0
    startAuth();
  })
}

/**
 * Run an approved command on the popup
 * Supported commands: moveTo, moveBy, resizeBy, resizeTo
 * @param {string} commandName 
 * @param {Array} argsArray 
 */
export function runCommand(commandName, argsArray) {
  if (ref.popup && !ref.popup.closed) {
    ref.popup.postMessage({ message: "run-command", command: commandName, args: argsArray }, url);
  }
}

export function focus() {
  if (ref.popup && !ref.popup.closed) {
    ref.popup.focus()
  }
}

export function close() {
  if (ref.popup && !ref.popup.closed) {
    ref.popup.close()
  }
}

//-----------------------------------------------
//-----private API
/**
 * We need to ping the popup to see if its ready for us at
 * 1 = on load, waiting for us to tell it to connect to linkedin
 * 2 = after auth, waiting for us to ask for the token
 * @param {*} num = 1|2 
 */
function startPing(num) {
  clearTimeout(pingId);
  pingId = setTimeout(() => {
    if (state !== STATES.PINGING) {
      return;
    }
    if (ref.popup.closed) {
      state = STATES.NONE;
      const promise = num === 1 ? openPromise : authPromise;
      promise.reject({ message: "user closed window" });
      return;
    }
    ref.popup.postMessage({ message: "ping-ready-" + num }, url);
    ref.popup.focus()
    startPing(num);
  }, 1000);
}
function startAuth() {
  ref.popup.postMessage({ message: "ping-auth-start" }, url);
  state = STATES.PINGING;
  startPing(2)
}
function handleMessage(e) {
  switch (e.data.message) {
    case "glg-li-ready-1":
      state = STATES.NONE;
      openPromise.resolve(autoAuth ? auth(closeOnDone) : true);
      break;
    case "glg-li-token":
      state = STATES.DONE;
      window.removeEventListener("message", handleMessage);
      if (e.data.success === "" && ++authRetry < 3) {
        // retry
        setTimeout(() => startAuth(), 1000);
      } if (e.data.success === "true") {
        if (closeOnDone) {
          ref.popup.close();
        }
        authPromise.resolve({ token: e.data.token, popup: ref.popup });
      } else {
        if (!ref.popup.closed) {
          ref.popup.close();
        }
        authPromise.reject({ message: "user cancelled" })
      }
      break;
    default:
  }
}